var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 3.7368H1.5V3.2368L12.5 2.3568V3.2368H14V1.7368C14 0.636803 13.109 -0.135197 12.021 0.0198027L1.98 1.4538C0.891 1.6098 0 2.6368 0 3.7368V13.7368C0 14.2672 0.210714 14.7759 0.585786 15.151C0.960859 15.5261 1.46957 15.7368 2 15.7368H14C14.5304 15.7368 15.0391 15.5261 15.4142 15.151C15.7893 14.7759 16 14.2672 16 13.7368V5.7368C16 5.20637 15.7893 4.69766 15.4142 4.32259C15.0391 3.94752 14.5304 3.7368 14 3.7368ZM12.5 10.7428C12.303 10.7427 12.1078 10.7039 11.9258 10.6284C11.7438 10.5529 11.5784 10.4423 11.4391 10.303C11.2998 10.1636 11.1894 9.99813 11.114 9.81606C11.0387 9.63398 10.9999 9.43885 11 9.2418C11.0001 9.04475 11.0389 8.84965 11.1144 8.66762C11.1899 8.4856 11.3005 8.32022 11.4398 8.18094C11.5792 8.04165 11.7447 7.93118 11.9267 7.85583C12.1088 7.78048 12.304 7.74174 12.501 7.7418C12.899 7.74194 13.2806 7.90015 13.5619 8.18164C13.8432 8.46313 14.0011 8.84484 14.001 9.2428C14.0009 9.64076 13.8427 10.0224 13.5612 10.3037C13.2797 10.585 12.898 10.7429 12.5 10.7428Z",
    fill: "#F07D00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWallet);
export default __webpack_public_path__ + "static/media/icon-wallet.fec84dc5a470879a376be72ce03c1b84.svg";
export { ForwardRef as ReactComponent };